// How a post statistic is shown (feature 013). The cabinet returns `null` for a figure it
// has no stored value for — never 0 — and echoes `statsAvailable: false` when the channel
// reports it has no post statistics at all.

export type PostFigureState = 'value' | 'unavailable' | 'notYetAvailable';

/** A network reports a post's figures some time after publication. */
export const POST_STATS_DELAY_MS = 2 * 24 * 60 * 60 * 1000;

const toTime = (date: string | number | null | undefined): number | null => {
    if (date === null || date === undefined || date === '') {
        return null;
    }
    // A number is a unix timestamp in seconds (the app's period convention).
    const time = typeof date === 'number' ? date * 1000 : new Date(date).getTime();
    return Number.isNaN(time) ? null : time;
};

/** Whether the post was published less than 2 days before `now`. */
export const isPostTooRecent = (publishedAt: string | number | null | undefined, now: number = Date.now()): boolean => {
    const time = toTime(publishedAt);
    return time !== null && now - time < POST_STATS_DELAY_MS;
};

export const postFigureState = (
    value: number | null | undefined,
    statsAvailable: boolean | null | undefined,
    publishedAt: string | number | null | undefined,
    now: number = Date.now(),
): PostFigureState => {
    if (value !== null && value !== undefined) {
        return 'value';
    }
    if (statsAvailable === false) {
        return 'unavailable';
    }
    return isPostTooRecent(publishedAt, now) ? 'notYetAvailable' : 'unavailable';
};
